import XApi from "../../utils/Api";
import XEndpoints from "../../core/config/Endpoints";

export class VariantService {
    async add(data: any) {
        const token = localStorage.getItem('token');
        if (token) {
            const response = await XApi.post(XEndpoints.variant, data, {
                'Content-Type': 'application/json',
                'Authorization': token,
            });
            return response ?? null;
        }
        return null;
    }

    async get(id: number) {
        const token = localStorage.getItem('token');
        if (token) {
            const response = await XApi.get(`${XEndpoints.variant}/detail/${id}`, {
                'Content-Type': 'application/json',
                'Authorization': token,
            });
            return response ?? null;
        }
        return null;
    }

    async update(id: string, data: any) {
        const token = localStorage.getItem('token');
        if (token) {
            const response = await XApi.patch(`${XEndpoints.variant}/detail/${id}`, data, {
                'Content-Type': 'application/json',
                'Authorization': token,
            });
            return response ?? null;
        }
        return null;
    }

    async all() {
        const token = localStorage.getItem('token');
        if (token) {
            const response = await XApi.get(`${XEndpoints.variant}/all`, {
                'Content-Type': 'application/json',
                'Authorization': token,
            });
            return response ?? null;
        }
        return null;
    }

}